import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseSupplierRequest() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      productID: isEmpty(state.productID),
      expiredate: isEmpty(state.expiredate),
      requestCount: isEmpty(state.requestCount),
    };

    setter(errorState);

    if (
      errorState.productID ||
      errorState.expiredate ||
      errorState.requestCount
    ) {
      enqueueSnackbar("لطفا اطلاعات درخواست را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getRequestList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_SupplierRequests?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllRequestList = (callback) => {
    MyAxios.get(`Admin_SupplierRequests?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getRequestByID = (id, callback) => {
    MyAxios.get(`Admin_SupplierRequests/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateRequest = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_SupplierRequests`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("درخواست با موفقیت ویرایش یافت", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addRequest = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_SupplierRequests`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("درخواست با موفقیت ایجاد شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const cancelRequest = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_SupplierRequests/Request`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("درخواست با موفقیت کنسل شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const cancelAllRequest = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_SupplierRequests/AllRequest`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("درخواست با موفقیت کنسل شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const sendSMS = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_SupplierRequests/SMS`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت ارسال شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getRequestList,
    getAllRequestList,
    getRequestByID,
    validate,
    updateRequest,
    addRequest,
    cancelRequest,
    cancelAllRequest,
    sendSMS,
  };
}
